export function canLoadPendingVatReviewCount(context) {
    return context?.currentIdentity?.user?.isAdministrator === true
        && context.currentUserProjectsLoaded === true;
}
